import { func, shape } from 'prop-types';
import React from 'react';
import { ModalBody, ModalHeader } from 'reactstrap';

import createModalToggle from '../../generic/create-modal-toggle';
import ImageCropper from '../../generic/ImageCropper/ImageCropperWrapper';

function ImageCropperButton({
  toggle,
  onSuccess,
  onDeleteCreative,
  imageData,
}) {
  return (
    <>
      <ModalHeader toggle={toggle}>Crop Creative</ModalHeader>
      <ModalBody>
        <ImageCropper
          onSuccess={onSuccess}
          onDeleteCreative={onDeleteCreative}
          imageData={imageData}
        />
      </ModalBody>
    </>
  );
}

ImageCropperButton.propTypes = {
  toggle: func.isRequired,
  onSuccess: func.isRequired,
  onDeleteCreative: func.isRequired,
  imageData: shape({}).isRequired,
};

export default createModalToggle(
  'Crop Creative',
  ImageCropperButton,
  { color: 'secondary', outline: true, size: 'sm', className: 'mt-1' },
  { size: 'lg' },
);
export { ImageCropperButton }; // for unit tests
